import { EventActionType } from './event-action-type';

export interface CreateEventSuccessAction {
  eventKey: string;
  type: EventActionType.CreateEventSuccess;
}

export const createEventSuccess = (
  eventKey: string,
): CreateEventSuccessAction => ({
  eventKey,
  type: EventActionType.CreateEventSuccess,
});
